import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import { formatActivityTime, getOutcomeStyles } from "../utils/formatters";
import { OUTLINE_BTN, CARD_TITLE } from "../utils/styles";

const RecentActivities = ({ stats, agent }) => {
    const history = useHistory();
    const [showAllActivities, setShowAllActivities] = useState(false);

    const recentActivities = stats?.recentActivities || [];
    const hasRecentActivities = recentActivities.length > 0;

    const handleViewAllClick = () => {
        if (agent === "oldleads") {
            history.push("/old-leads");
        } else if (agent === "newleads") {
            history.push("/new-data-call");
        } else {
            setShowAllActivities(!showAllActivities);
        }
    };

    return (
        <div className="card card-custom shadow-sm border-0 bg-white rounded-lg p-5 p-md-6">
            <div className="card-body p-0">
                <div className="d-flex align-items-center justify-content-between mb-5">
                    <h3
                        className="card-title font-weight-bolder text-dark font-size-h5 m-0"
                        style={CARD_TITLE}
                    >
                        Recent Activities
                    </h3>
                    {(recentActivities.length > 4 || agent === "oldleads" || agent === "newleads") && (
                        <button
                            type="button"
                            onClick={handleViewAllClick}
                            className="btn btn-outline-primary px-3 py-1 rounded-lg font-weight-bolder"
                            style={OUTLINE_BTN}
                        >
                            {(agent === "oldleads" || agent === "newleads") ? "View All" : (showAllActivities ? "View Less" : "View All")}
                        </button>
                    )}
                </div>
                <div
                    style={{
                        overflowX: "hidden",
                        overflowY: showAllActivities ? "auto" : "visible",
                        maxHeight: showAllActivities ? "400px" : "none",
                        height: "auto",
                        paddingRight: "8px",
                        scrollbarWidth: "thin",
                        scrollbarColor: "#6f42c1 transparent"
                    }}
                >
                    {hasRecentActivities ? (
                        <div className="d-flex flex-column" style={{ gap: "12px", position: "relative", paddingLeft: "16px", borderLeft: "2px solid #EFEBFC", marginLeft: "10px" }}>
                            {recentActivities
                                .filter((row, idx) => (showAllActivities ? true : idx < 4))
                                .map((act, idx) => {
                                    const timeStr = formatActivityTime(act.createdOn);
                                    const memberName = act.saleName || "Admin";
                                    const companyName = agent === "oldleads" ? "" : (act.CompanyName || act.companyName || "");
                                    const styles = getOutcomeStyles(act.elevenlabs_call_outcome_status);

                                    // Dot glowing color
                                    const dotColor = styles.dot || "#8A58EC";

                                    return (
                                        <div
                                            key={idx}
                                            className="position-relative p-3 transition-all"
                                            style={{
                                                backgroundColor: "#F9F9FC",
                                                borderRadius: "10px",
                                                border: "1px solid #F1F1F4",
                                                transition: "all 0.2s ease-in-out",
                                            }}
                                            onMouseEnter={(e) => {
                                                e.currentTarget.style.boxShadow = "0 4px 12px rgba(111, 66, 193, 0.04)";
                                                e.currentTarget.style.borderColor = "#EFEBFC";
                                                e.currentTarget.style.backgroundColor = "#FFFFFF";
                                            }}
                                            onMouseLeave={(e) => {
                                                e.currentTarget.style.boxShadow = "none";
                                                e.currentTarget.style.borderColor = "#F1F1F4";
                                                e.currentTarget.style.backgroundColor = "#F9F9FC";
                                            }}
                                        >
                                            {/* Timeline indicator dot */}
                                            <div
                                                className="position-absolute"
                                                style={{
                                                    left: "-23px",
                                                    top: "16px",
                                                    width: "12px",
                                                    height: "12px",
                                                    borderRadius: "50%",
                                                    backgroundColor: dotColor,
                                                    border: "3px solid #FFFFFF",
                                                    boxShadow: `0 0 0 3px ${dotColor}20`
                                                }}
                                            />

                                            {/* Row 1: Name + Company & Time */}
                                            <div className="d-flex flex-wrap align-items-center justify-content-between mb-2" style={{ gap: "8px" }}>
                                                <div className="d-flex align-items-center flex-wrap" style={{ gap: "6px" }}>
                                                    <span className="font-weight-boldest text-dark" style={{ fontSize: "0.88rem", color: "#181C32", fontWeight: "700" }}>
                                                        {memberName}
                                                    </span>
                                                    {companyName && (
                                                        <>
                                                            <span className="text-muted" style={{ fontSize: "0.75rem" }}>•</span>
                                                            <span className="font-weight-boldest" style={{ fontSize: "0.82rem", color: "#6366f1", fontWeight: "700", wordBreak: "break-all" }}>
                                                                {companyName}
                                                            </span>
                                                        </>
                                                    )}
                                                </div>
                                                <div className="d-flex align-items-center text-muted" style={{ fontSize: "0.75rem", fontWeight: "500" }}>
                                                    <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ marginRight: "4px" }}>
                                                        <circle cx="12" cy="12" r="10" />
                                                        <polyline points="12 6 12 12 16 14" />
                                                    </svg>
                                                    <span>{timeStr}</span>
                                                </div>
                                            </div>

                                            {/* Row 2: Description & Outcome status badge */}
                                            <div className="d-flex flex-wrap align-items-center justify-content-between mt-2" style={{ gap: "8px" }}>
                                                <span className="text-dark-75" style={{ fontSize: "0.8rem", fontWeight: "500", flex: "1 1 auto", minWidth: "150px" }}>
                                                    Outbound session
                                                </span>
                                                <span
                                                    className="d-inline-flex align-items-center justify-content-center px-2 py-1 font-weight-boldest rounded"
                                                    style={{
                                                        fontSize: "0.7rem",
                                                        backgroundColor: styles.bg,
                                                        color: styles.color,
                                                        borderRadius: "6px",
                                                        height: "20px",
                                                        minWidth: "75px",
                                                        flexShrink: 0
                                                    }}
                                                >
                                                    {styles.label}
                                                </span>
                                            </div>
                                        </div>
                                    );
                                })}
                        </div>
                    ) : (
                        <div className="text-center py-10 text-muted font-weight-bold" style={{ fontSize: "0.9rem" }}>
                            No recent activity recorded
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default React.memo(RecentActivities);
